import { selectChangeMessageForColor } from '@UI/aside/asideColor/asideColorSelectors';
import { selectChangeMessageForVideoAttachments } from '@UI/aside/asideVideo/asideVideoSelectors';
import { ContentType } from '@generalTypes/apiTypes';
import { selectZillDevelopmentFieldNode } from '@newStore/documentUI/transformContent/zillContentNodeSelectors';
import { selectIsVideoLinkValidRule } from '@newStore/validation/validationRules/videoLinkRules';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { attachedContentComponent } from '@nodeTypeConfig/helpers/editComponents/attachedContent';
import { descriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';
import { identifierComponent } from '@nodeTypeConfig/helpers/editComponents/identifierComponent';
import { imageComponentBase } from '@nodeTypeConfig/helpers/editComponents/imageComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const CURRICULUM_ZILL_DEVELOPMENT_FIELD: BuildingBlockNodeConfig = {
  nodeSelector: selectZillDevelopmentFieldNode,
  information: {
    single: 'Veld',
    plural: 'Velden',
  },
  createDefaults: {
    attachments: [
      {
        type: 'CONTENT',
        name: 'content.html',
        contentType: 'text/html',
      },
    ],
  },
  buildingBlocks: [{ type: NodeType.CURRICULUM_ZILL_DEVELOPMENT_THEME }],
  edit: [
    {
      ...identifierComponent,
      width: 2,
    },
    {
      ...titleComponent,
      width: 10,
    },
    descriptionComponent,
    {
      ...attachedContentComponent,
      label: 'Lees meer',
    },
    {
      ...imageComponentBase,
      label: 'Ikoon',
      options: {
        type: 'ICON',
        fields: [],
      },
    },
    {
      component: 'color',
      property: 'color',
      reactComponent: 'AsideColor',
      label: 'Kleur',
      asideChangeMessageSelector: selectChangeMessageForColor,
    },
    {
      ...imageComponentBase,
      label: 'Omslagfoto',
      options: {
        type: 'COVER_IMAGE',
        fields: [],
      },
    },
    {
      ...imageComponentBase,
      label: 'Miniatuur',
      options: {
        type: 'THUMBNAIL',
      },
    },
    {
      ...imageComponentBase,
      label: 'Achtergrond',
      options: {
        type: 'BACKGROUND_IMAGE',
        fields: [],
      },
    },
    {
      component: 'video',
      reactComponent: 'AsideVideo',
      label: 'Video',
      property: 'attachments',
      options: { type: ContentType.VIDEO },
      asideChangeMessageSelector: selectChangeMessageForVideoAttachments,
      validations: [selectIsVideoLinkValidRule],
    },
  ],
  documentViewIdentifier: 'i',
  isCollapsible: true,
  isCollapsedByDefault: true,
  onNewNodeDropped: {
    focusOnField: 'title',
  },
};

export default CURRICULUM_ZILL_DEVELOPMENT_FIELD;
